import styled, { css } from 'styled-components';
import Typography from '../Typography/Typography';
import Colors from '../Colors';

export const Root = styled.div<{
  $includeContainerCard?: boolean;
  $disableScroll?: boolean;
  $maxHeightInVH?: number;
}>`
  ${(props) => (props.$includeContainerCard ? RootMixin : '')}
  ${(props) => (props.$disableScroll ? DisableScrollMixin : '')}
`;

export const TypographyNoMargin = styled(Typography)`
  margin: 0;
`;

export const InputContainer = styled.div<{ $includeContainerCard?: boolean }>`
  ${(props) => (props.$includeContainerCard ? InputContainerMixin : '')}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid ${Colors.Gray[100]};
`;

export const IconsContainer = styled.span`
  color: ${Colors.Primary[700]};
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${Colors.Gray[100]};
`;

export const Option = styled.div`
  padding: 10px 16px;

  &:hover {
    background: ${Colors.Primary[50]};
  }
`;

export const IncludeExcludeOption = styled(Option)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const IncludeExcludeLabel = styled.span<{
  $excluded?: boolean;
  $included?: boolean;
}>`
  overflow-wrap: break-word;
  font-weight: ${(props) => (props.$included ? 500 : 400)};
  font-size: 0.875rem;
  line-height: 20px;
  color: ${(props) => (props.$excluded ? Colors.Gray[400] : Colors.Gray[700])};
  text-decoration: ${(props) => (props.$excluded ? 'line-through' : 'none')};
`;

export const IncludeExcludeButtons = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  gap: 4px;
`;

export const IncludeExcludeButton = styled.button<{
  $active: boolean;
  $activeBackground: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border: none;
  border-radius: 6px;
  background: ${(props) =>
    props.$active ? props.$activeBackground : 'transparent'};
  cursor: pointer;

  &:hover {
    background: ${(props) =>
      props.$active ? props.$activeBackground : Colors.Gray[100]};
  }
`;

export const GroupedOption = styled(Option)`
  padding-left: 40px;
`;

export const GroupOption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 16px;

  &:hover {
    background: ${Colors.Primary[50]};
  }

  label {
    font-weight: 500;
  }
`;

export const GroupCollapseButton = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const GroupCount = styled.span`
  margin-left: auto;
  padding-left: 8px;
  color: ${Colors.Gray[400]};
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
`;

export const ShowMoreOption = styled.span`
  padding: 10px 16px;
  color: ${Colors.Primary[700]};
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
`;

export const NoMatches = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* Mixins */

const RootMixin = css<{ $maxHeightInVH?: number }>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 240px;
  max-height: ${(props) => props.$maxHeightInVH ?? 80}vh;
  overflow-y: auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.1),
    0px 4px 6px -2px rgba(16, 24, 40, 0.05);
`;

const DisableScrollMixin = css`
  max-height: unset;
  overflow-y: unset;
`;

const InputContainerMixin = css`
  padding: 10px 16px;
`;
